// [全局]页面跳转
export const loadPage = {
  methods: {
    loadPage(routerName, params) {
      // console.log('跳转路由: %s ,参数: %o', routerName, params)
      if (params) {
        this.$router.push({
          name: routerName,
          query: params
        })
      } else {
        this.$router.push({
          name: routerName
        })
      }
    }
  }
}

// 跳转静默授权
export const oauth2 = {
  methods: {
    // 重定向到 "确认授权" 页面
    redirectToAuthorize(url) {
      const redirectUrl = url || location.href
      const appId = this.$consts.APP_ID
      const authType = this.$consts.AUTH_TYPE || 'snsapi_base'
      console.log(`跳转静默授权前页面路径 location.href = ${redirectUrl}, appId = ${appId}`)
      // this.$sentry.captureMessage({ action: '页面跳转', location: location.href, appId: appId })
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=${authType}&connect_redirect=1#wechat_redirect`)
    }
  }
}

export const polling = {
  methods: {
    /**
     * 轮询
     * @param {Function} fn 轮询方法
     * @param {String} msg 轮询提示
     * @param {Integer} pollTimes 轮询次数
     * @param {Integer} milliseconds 轮询间隔
     */
    polling(fn, msg = '加载中', pollTimes = 5, milliseconds = 1000) {
      const self = this
      setInterval(() => {
        pollTimes--
        if (pollTimes) {
          self.$toast.loading(msg)
          setTimeout(fn, 0)
        } else {
          self.$toast.clear()
        }
      }, milliseconds)
    }
  }
}
